import { useState } from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import database from '../config/firebase';
import MenuItem from '@mui/material/MenuItem';

export default function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("General problems with the website");

  const subjectlist = [
  {
    value: 'subject1',
    label: 'General problems with the website',
  },
  {
    value: 'subject2',
    label: 'Report offensive or abusive behavior',
  },
  {
    value: 'subject3',
    label: 'Question about Apps',
  },
  {
    value: 'subject4',
    label: 'DMCA',
  },
  {
    value: 'subject5',
    label: 'Watchface issues',
  },
  {
    value: 'subject6',
    label: 'Other question',
  },
];

	 
 
  const handleSubmit = (e) => {
    e.preventDefault();
    const msgref = database.ref("messages");
	const newContactRef = msgref.push();
	newContactRef.set({
			name: name,
			email: email,
			message: message,
			subject: subject,
		}).catch(alert);
	setName('');
	setEmail('');	
	setMessage('');	
	setSubject('');
};

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Box sx={{ maxWidth: 600, mx: "auto", p: 2 }}>
        <Typography variant="h4" align="center" mb={2}>
          Contact Us
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
            type="email"
          />
		  
		  <TextField
			  id="selectsubject"
			  select
			 
			  defaultValue={subject}
			  onChange={(e) => setSubject(e.target.value)}
			  helperText="Choose a topic"
			>
          {subjectlist.map((option) => (
            <MenuItem key={option.value} value={option.label} >
              {option.label}
            </MenuItem>
          ))}
        </TextField>
          <TextField
            fullWidth
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            margin="normal"
            required
            multiline
            rows={4}
          />
          <Button variant="contained" type="submit" sx={{ mt: 2 }}>
            Submit
          </Button>
		  
        </form>
      </Box>
    </Box>
  );
}